import { loadStripe, Stripe } from '@stripe/stripe-js';
import { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectDealershipSettings } from 'services/DealershipSettings/selectors';

import { STRIPE_API_KEY } from '../../env';

export const StripeContext = createContext<Stripe | null>(null);

const StripeProvider = ({ children }) => {
  const settings = useSelector(selectDealershipSettings());

  const [stripe, setStripe] = useState<Stripe | null>(null);

  useEffect(() => {
    let unmounted = false;

    if (settings.paymentAccountId) {
      loadStripe(STRIPE_API_KEY, { stripeAccount: settings.paymentAccountId }).then((stripe) => {
        if (!unmounted) {
          setStripe(stripe);
        }
      });
    }

    return () => {
      unmounted = true;
    };
  }, [settings.paymentAccountId]);

  return <StripeContext.Provider value={stripe}>{children}</StripeContext.Provider>;
};

export const useStripe = () => {
  const stripe = useContext(StripeContext);

  return stripe;
};

export default StripeProvider;
